import { env } from "../config/env";
import { getPublicMediaUrl } from "../lib/media/getPublicMediaUrl";
import { ApiError, getAccessToken } from "./client";
import { notifyUnauthorized } from "./unauthorized";

type UploadOnlyResizeItem = {
  only_resized?: string;
  onlyResized?: string;
};

type UploadOnlyResizeResponse = {
  data?: UploadOnlyResizeItem[];
};

/** POST /api/v1/uploadOnlyResize — без водяного знака. */
export async function uploadDisplayImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("files[]", file);
  const token = getAccessToken();

  const response = await fetch(`${env.apiBaseUrl}/api/v1/uploadOnlyResize`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: formData,
  });

  if (!response.ok) {
    if (response.status === 401) {
      notifyUnauthorized();
    }
    let message = `Upload failed: ${response.status}`;
    try {
      const body = (await response.json()) as { message?: string };
      if (body.message?.trim()) message = body.message.trim();
    } catch {
      // ignore
    }
    throw new ApiError(message, response.status);
  }

  const json = (await response.json()) as UploadOnlyResizeResponse;
  const image = json.data?.[0];
  const s3Key = image?.only_resized ?? image?.onlyResized;

  if (!s3Key) {
    throw new ApiError("Upload response missing only_resized key", 500);
  }

  return getPublicMediaUrl(s3Key);
}
